module.exports = __webpack_public_path__ + "img/4.08b076ad.png";